<div
  class="bg-white dark:bg-black-dark flex justify-end pb-2 border-b border-borders-dark dark:border-black-dark-light px-1"
>
  <div class="text-[16px] font-bold pt-[7px] pr-3">
    {{ user.firstname }} {{ user.lastname }}
  </div>
  <div class="img w-[40px]">
    <app-user-avatar
      [name]="user.username"
      [firstname]="user.firstname"
      [lastname]="user.lastname"
      [picture]="user.picture"
      [size]="36"
    ></app-user-avatar>
  </div>
</div>

<div
  class="noScrollbar overflow-y-scroll max-h-[calc(100vh-(var(--sab)+var(--sat))-80px)] pb-2 mobile:max-h-[380px]"
>
  <div class="links mt-2">
    <h3 class="font-light mb-1 pb-1">
      {{ "LINKS" | translate }}
    </h3>
    <ul>
      <li>
        <a
          class="arrow"
          (click)="closeModals()"
          routerLink="/account/profile"
          >{{ "MY_PROFILE" | translate }}</a
        >
      </li>
      <li>
        <a
          class="arrow"
          (click)="closeModals()"
          routerLink="/account/preferences"
          >{{ "MY_PREFERENCES" | translate }}</a
        >
      </li>
      <li>
        <a
          class="arrow"
          (click)="closeModals()"
          routerLink="/account/imports"
          >{{ "ACCOUNT_IMPORTS_NAV_CTA" | translate }}</a
        >
      </li>
      <li>
        <a class="arrow" routerLink="/friends">{{
          "MY_FRIENDS" | translate
        }}</a>
      </li>
      <li>
        <a class="arrow" (click)="closeModals()" routerLink="/stats">{{
          "STATISTICS" | translate
        }}</a>
      </li>
      @if (user && user.role && user.role >= 5) {
      <li>
        <a class="arrow" (click)="closeModals()" routerLink="/admin"
          ><span class="text-primary-text">{{ "ADMIN" | translate }}</span></a
        >
      </li>
      }
      <li>
        <a class="arrow" (click)="closeModals()" routerLink="/about">{{
          "ABOUT_GEMSTER" | translate
        }}</a>
      </li>
    </ul>
  </div>

  <app-store-links [alignLeft]="true" class="[&>div]:mt-3" />

  <div class="settings mt-5">
    <h3
      class="font-light mb-2 pb-1 border-b border-borders-light dark:border-borders-darker"
    >
      {{ "PREFERENCES" | translate }}
    </h3>
    <app-edit-profile-preferences
      [hidden]="true"
      [user]="user"
    ></app-edit-profile-preferences>
  </div>
  <div class="mt-5 mb-4 text-center">
    <button
      (click)="logout()"
      (keyup)="onKeyUp($event, 'logout')"
      tabindex="0"
      class="inline-block font-bold text-form-error dark:text-form-errorLight"
    >
      {{ "LOG_OUT" | translate }}
    </button>
  </div>
</div>
